module.exports = __webpack_public_path__ + "static/media/57.786b354c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/57.jpg
// module id = 618
// module chunks = 0